import React from 'react';
import styled from 'styled-components';
import {getDevice} from 'utils/getDevice';
import DefaultImageView from './DefaultImageView';
import DefaultText from './DefaultText';
import {useNavigate} from 'react-router-dom';

/**
 * 좁은 헤더 컴포넌트의 Props 타입
 * @property {string} title - 제목
 * @property {() => void} [onClickBackButton] - 뒤로가기 버튼 클릭 이벤트 핸들러
 */
type Props = {
  title: string;
  onClickBackButton?: () => void;
};

/**
 * 좁은 헤더 컴포넌트
 * 뒤로가기 버튼과 제목을 표시하는 좁은 헤더 컴포넌트입니다.
 * @param {Props} props - 좁은 헤더 컴포넌트의 props
 * @returns {JSX.Element} 좁은 헤더 컴포넌트
 */
const NarrowHeader = ({title, onClickBackButton}: Props) => {
  const device = getDevice();
  const navigate = useNavigate();
  return (
    <Container $device={device}>
      <div style={{position: 'absolute', left: '12px'}}>
        <DefaultImageView
          source="images/common/left_arrow.png"
          style={{
            width: 'max(40px, min(3.2vw, 64px))',
            cursor: 'pointer',
          }}
          onClick={() =>
            onClickBackButton ? onClickBackButton() : navigate(-1)
          }
        />
      </div>

      <DefaultText
        text={title}
        textStyle={{
          fontSize: 'max(22px, min(2vw, 36px))',
        }}
      />
    </Container>
  );
};

export default NarrowHeader;

const Container = styled.div<{$device?: string}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: max(40px, min(3.2vw, 64px));
  position: relative;
`;
